import React, { useState } from 'react';
import styles from './CustomerReview.module.scss';
import { Typography } from '@mui/material';
import { TabButton } from '../../../../commons/hoc';
import CustomerStories from '../../homepage/customerStories/customerStories';

export default function CustomerReview() {
  const [selectedCategory, setSelectedCategory] = useState('REL');
  const tabBtnList = [
    {
      id: 'REL',
      name: 'Relief Factor',
    },
    {
      id: 'ZEN',
      name: 'Zen Factor',
    },
    {
      id: 'GOF',
      name: 'Go Factor',
    },
    {
      id: 'ZFA',
      name: 'Z Factor',
    },
  ];

  const handleCategoryChange = (id) => {
    setSelectedCategory(id);
  };
  return (
    <>
      <div className={styles.gettinStartedExtender}>
        <div className={styles.reviewWrapper}>
          <div className={styles.reviewContainer}>
            <div className={styles.titleHeader}>
              <Typography
                variant="h1"
                color="primary"
                component="span"
                className={styles.sectionTitle}
              >
                Hear Directly From People <span>Just Like You.</span>
              </Typography>
            </div>
            <div className={styles.reviewTabBtn}>
              <TabButton
                btnList={tabBtnList}
                activeIdx={selectedCategory}
                setIdxCB={handleCategoryChange}
                className={styles.reviewTabBtnItem}
              />
            </div>
          </div>
        </div>
        <CustomerStories
          productType={selectedCategory}
          hasBackgroundColor={false}
        />
        <div className={styles.divider}></div>
      </div>
    </>
  );
}
